import { render, staticRenderFns } from "./updateAppUserInfo.vue?vue&type=template&id=124d4b0c&scoped=true"
import script from "./updateAppUserInfo.vue?vue&type=script&lang=js"
export * from "./updateAppUserInfo.vue?vue&type=script&lang=js"
import style0 from "./updateAppUserInfo.vue?vue&type=style&index=0&id=124d4b0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124d4b0c",
  null
  
)

export default component.exports